// extracted by mini-css-extract-plugin
export default {"cardHeader":"CartItem_cardHeader__ZV7C3","imgBg":"CartItem_imgBg__Cgpjm","cardTitle":"CartItem_cardTitle__MGm7b"};